// Re-renders the component on an interval. Set to null to stop
import { useInterval, useUpdate } from 'react-use';

export default function useRerenderInterval(ms: number | null) {
  useInterval(useUpdate(), ms);
}
